import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      STEPS: [
        { title: "Lag din matkasse" },
        { title: "Opprett konto" },
        { title: "Adresse" },
        { title: "Kasse" },
        { title: "Velg retter" },
      ],
    },
    se: {
      STEPS: [
        { title: "Skapa din matkasse" },
        { title: "Skapa konto" },
        { title: "Adress" },
        { title: "Kassa" },
        { title: "Välj ratter" },
      ],
    },
    dk: {
      STEPS: [
        { title: "Design din måltidskasse" },
        { title: "Opret konto" },
        { title: "Adresse" },
        { title: "Checkout" },
        { title: "Vælg retter" },
      ],
    },
  } as const
)[language];
